const enModules = import.meta.glob('./en/**/*.json', { eager: true });
const frModules = import.meta.glob('./fr/**/*.json', { eager: true });

const importAllTranslations = (modules) => {
    const translations = {};
    for (const path in modules) {
        Object.assign(translations, modules[path].default || modules[path]);
    }
    return translations;
};

export const enMessages = importAllTranslations(enModules);
export const frMessages = importAllTranslations(frModules);

export default {
    en: enMessages,
    fr: frMessages,
};
